// Child Component of: 
// --- BaseBlock

// Import React and Material-UI Modules
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Input from '@material-ui/core/Input';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

// Material-UI CSS-type Style Specifications
const styles = (theme) => ({
    paper: {
      width: 515,//600
      height: 200,
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      square: false,
      boxShadow: theme.shadows[5],
    },
    grid: {
        justify: 'flex-start',
    },
    titleText: {
        color: "white",
        margin: theme.spacing(1),
    },
    inputField: {
        width: "100%",
        color: "white",
        marginTop: theme.spacing(0.6),
        marginLeft: theme.spacing(1),
        textAlign: "center",
    },
    inputFieldRC: {
        width: "100%",
        color: "white",
        marginTop: theme.spacing(0.6),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        textAlign: "center",
    },
    regularText: {
        color: "white",
        margin: theme.spacing(1),
    },
    textButton: {
        color: "white",
        margin: theme.spacing(0),
        border: '1px solid #000',
    },
});




// Component Class
class LocoCrazeBlocks extends React.Component {

    state = {
        LCBlocksOptions: {
            idrone: {
                id: 0,
                //title: 'Drone',
                height: 100,
                color: '#fbc22d',
                control: {in1: 'E7E7E7E7E7', in2: 80, isFixed: true,},
                codeRef(ctrl) {
                    return [ 
                        `DRONE_ADDR = '${ctrl.in1}'`,
                        `DRONE_CHAN = ${ctrl.in2}`,
                    ]
                },
                code: [],
                text1: 'Drone Address',
                text2: 'Drone Channel',
                in1Width: '100px',
                in2Width: '40px',
                in1Type: 'hexString',
                in2Type: 'int',
                in2Limits: [0, 125],
            },
            itakeoff: 
            {
                id: 0,
                title: 'Takeoff',
                height: 135, 
                color: '#ec4078',
                control: {},
                code: ['# Command Drone to Takeoff', 'loco_craze.drone_takeoff()'],
            },
            iland: 
            {
                id: 0,
                title: 'Land',
                height: 135, 
                color: '#ec4078',
                control: {},
                code: ['# Command Drone to Land', 'loco_craze.drone_land()'],
            },
            iloop:
            {
                id: 0,
                title: 'Loop',
                height: 135, 
                color: '#8057c1',
                control: {in1: 0, },
                codeRef(ctrl) {
                    return [`# Loop for ${ctrl.in1} times`, `for i in range(${ctrl.in1}):`]
                },
                code: [],
                inWidth: '40px',
                in1Type: 'int',
                text1: 'Repeat',
                text2: 'times',
            },
            iloopend:
            {        
                id: 0,
                title: 'LoopEnd',
                height: 135, 
                color: '#8057c1',
                control: {},
                code: [],
            },
            ihover:
            {
                id: 0,
                title: 'Hover',
                height: 135, 
                color: '#fbc22d',
                control: {in1: 0, },
                codeRef(ctrl) {
                    return [`# Hover for ${ctrl.in1} seconds`, `loco_craze.drone_hover()`, `time.sleep(${ctrl.in1})`]
                },
                code: [],
                inWidth: '40px',
                in1Type: 'float',
                text1: 'Hover for',
                text2: 'seconds',
                in1Limits: [0, 10],
            },
            iyaw: {
                id: 0,
                title: 'Yaw',
                height: 135, 
                color: '#2196f3',
                control: {btn1: 'YAW_CW', btn1Txt: 'Clockwise', in1: 1, },
                codeRef(ctrl) {
                    return [`# Yaw ${ctrl.btn1Txt} for ${ctrl.in1} degrees`, `loco_craze.drone_yaw(loco_craze.${ctrl.btn1}, ${ctrl.in1})`]
                },
                code: [],
                text1: 'Yaw ',
                text2: 'for',
                text3: 'degrees',
                btn1Options: ['Clockwise', 'Counter-clockwise'],
                btn1map: {'Clockwise': 'YAW_CW', 'Counter-clockwise':'YAW_CCW'},
                inWidth: '40px',
                in1Type: 'int',
                in1Limits: [1, 360],
            },
            imove: {
                id: 0,
                title: 'Move',
                height: 135, 
                color: '#009788',
                control: {btn1: '1', btn1Txt: 'UP', in1: 20, },
                codeRef(ctrl) {
                    return [`# Move ${ctrl.btn1Txt} for ${ctrl.in1} centimeters`, `loco_craze.drone_move(loco_craze.MOVE_${ctrl.btn1Txt}, ${ctrl.in1})`]
                },
                code: [],
                text1: 'Move ',
                text2: 'for',
                text3: 'centimeters',
                btn1Options: ['UP', 'DOWN', 'LEFT', 'RIGHT', 'FORWARD', 'BACK'],
                btn1map: {'UP':'UP', 'DOWN':'DOWN', 'LEFT':'LEFT', 'RIGHT':'RIGHT', 'FORWARD':'FORWARD', 'BACK':'BACK'},
                inWidth: '40px',
                in1Type: 'int',
                in1Limits: [20, 500],
            },
            igo: {
                id: 0,
                title: 'Go To',
                height: 150, 
                color: '#4DAF4E',
                control: {in1: 0, in2: 0, in3: 0, in4: 20, },
                codeRef(ctrl) {
                    return [`# Go to (${ctrl.in1}, ${ctrl.in2}, ${ctrl.in3}) at ${ctrl.in4} cm/s`, `loco_craze.drone_go([${ctrl.in1},${ctrl.in2},${ctrl.in3}], ${ctrl.in4})`]
                },
                code: [],
                text1: 'Go to (',
                text2: ')',
                text3: 'at ',
                text4: 'cm/s',
                inWidth: '40px',
                in1Type: 'int',
                //in1Limits: [-500, 500],
                in2Type: 'int',
                //in2Limits: [-500, 500],
                in3Type: 'int',
                //in3Limits: [-500, 500],
                in4Type: 'int',
                in4Limits: [10, 100],
                in1Cust: '',
                in2Cust: '',
                in3Cust: '',
                boundRef(x) {
                    let m = x
                    if (m < -500) {
                        m = -500
                    } else if (m > 500) {
                        m = 500
                    } else if ((m >= 1) && (m <= 9)) {
                        m = 0
                    } else if ((m <= -1) && (m >= -9)) {
                        m = 0
                    } else if ((m <= -10) && (m >= -19)) {
                        m = -20
                    } else if ((m >= 10) && (m <= 19)) {
                        m = 20
                    }
                    return m;
                },
            },
            icircle: {
                id: 0,
                title: 'Circle',
                height: 150,
                color: '#FF2424',
                control: {btn1:1, btn1Txt: 'LEFT', in1: 0, in2: 0},
                codeRef(ctrl) {
                    return [`# Circle ${ctrl.btn1} for ${ctrl.in1} degrees for radius ${ctrl.in2} m`,
                            `loco_craze.drone_circle(loco_craze.CIRCLE_${ctrl.btn1}, ${ctrl.in2}, ${ctrl.in1})`,
                            ]
                },
                code: [],
                text1: 'Fly Drone ',
                text2: 'in a circle for ',
                text3: 'degrees at a radius of ',
                text4: ' meters.',
                btn1Options: ['LEFT', 'RIGHT'],
                btn1map: {'LEFT':'LEFT', 'RIGHT':'RIGHT'},
                inWidth: '40px',
                in1Type: 'int',
                in1Limits: [1, 360],
                in2Type: 'float',
                in2Limits: [0.1, 1],
            },
            irc: {                
                id: 0,
                title: 'Virtual Joystick',
                height: 180, 
                color: '#f16749',
                control: {in1: 0, in2: 0, in3: 0, in4: 0, in5: 0, btn1: 1, btn2: 1, btn3: 1, btn4: 1},
                codeRef(ctrl) {
                    return [`# RC Control ${ctrl.in1}, ${ctrl.in2}, ${ctrl.in3}, ${ctrl.in4} for ${ctrl.in5} seconds`, 
                            `loco_craze.drone_rc(${Number(ctrl.btn1) * Number(ctrl.in1)}, ${Number(ctrl.btn2) * Number(ctrl.in2)}, ${Number(ctrl.btn3) * Number(ctrl.in3)}, ${Number(ctrl.btn4) * Number(ctrl.in4)})`,
                            `time.sleep(${ctrl.in5})`,
                            `loco_craze.drone_rc(0, 0, 0, 0)`]
                },
                code: [],
                inWidth: '40px',
                in1Type: 'int',
                in1Limits: [0, 100],
                in2Type: 'int',
                in2Limits: [0, 100],
                in3Type: 'int',
                in3Limits: [0, 100],
                in4Type: 'int',
                in4Limits: [0, 100],
                in5Type: 'float',
                in5Limits: [1, 14],
                text1: 'for',
                text2: 'seconds',
                btn1Options: ['Left', 'Right'],
                btn1map: {'Left':-1, 'Right':1},
                btn2Options: ['Forward', 'Backward'],
                btn2map: {'Forward':1, 'Backward':-1},
                btn3Options: ['Up', 'Down'],
                btn3map: {'Up':1, 'Down':-1},
                btn4Options: ['Yaw CW', 'Yaw CCW'],
                btn4map: {'Yaw CW':1, 'Yaw CCW':-1, 'Yaw Clockwise':1, 'Yaw Couter-Clockwise':-1},
            }
        },
        renderType: this.props.blockType,
        btn1: 0,
        btn2: 0,
        btn3: 0,
        btn4: 0,
        btn1Txt: '',
        btn2Txt: '',
        btn3Txt: '',
        btn4Txt: '',
        in1: 0,
        in2: 0,
        in3: 0,
        in4: 0,
        in5: 0,
    }

    componentDidMount() {
        let updates = {control: this.props.control};
        this.componentRefresh(updates);
    }

    componentRefresh = (updates) => {
        
        if (this.state.renderType === 'idrone') {
            this.props.setFixedState(true);
        }
        let tempRenderType = this.state.renderType;
        
        if ('name' in updates) {
            tempRenderType = updates.name;
            this.setState( {renderType: updates.name} );
        }

        let tempLCBlocks = { ...this.state.LCBlocksOptions };

        tempLCBlocks[tempRenderType].id = this.props.id
        if ((typeof updates.control !== "undefined") && (Object.keys(updates.control).length !== 0)) {
            let keyNames = Object.keys(updates.control);
            keyNames.forEach((val, i) => {
                tempLCBlocks[tempRenderType].control[val] = updates.control[val];
                this.setState( {[val]: updates.control[val]} );
                if (tempLCBlocks[tempRenderType].hasOwnProperty('codeRef')) {
                    tempLCBlocks[tempRenderType].code = tempLCBlocks[tempRenderType].codeRef(tempLCBlocks[tempRenderType].control);
                }
            });
        } else {
            if (tempLCBlocks[tempRenderType].hasOwnProperty('codeRef')) {
                tempLCBlocks[tempRenderType].code = tempLCBlocks[tempRenderType].codeRef(tempLCBlocks[tempRenderType].control);
            }

            const controls = ['btn1', 'btn2', 'btn3', 'btn4', 'in1', 'in2', 'in3', 'in4', 'in5'];

            controls.forEach(control => {
                if (control in tempLCBlocks[tempRenderType].control) {
                    if (control.startsWith('btn')) {
                        const optionKey = `${control}Options`;
                        const mapKey = `${control}map`;
                        tempLCBlocks[tempRenderType].control[control] = tempLCBlocks[tempRenderType][mapKey][tempLCBlocks[tempRenderType][optionKey][0]];
                        tempLCBlocks[tempRenderType].control[`${control}Txt`] = tempLCBlocks[tempRenderType][optionKey][0];
                        this.setState({ [`${control}Txt`]: tempLCBlocks[tempRenderType].control[`${control}Txt`] });
                    } else if (control.startsWith('in')) {
                        this.setState({ [control]: tempLCBlocks[tempRenderType].control[control] });
                    }
                }
            });
        }
        
        this.setState( {LCBlocksOptions: tempLCBlocks} );
        this.props.handleSubState(tempLCBlocks[tempRenderType]);
    }

    handleInOnBlur = (event, name) => {
        if (!this.state.hasOwnProperty(name)) {
            return
        }
        //let m = event.target.value
        //let inName = event.target.name

        let m = this.state[name]
        let inName = name

        let inLimits = inName + 'Limits'
        let inCust = inName + 'Cust'
        let inType = inName + "Type"

        let tempLCBlocks = this.state.LCBlocksOptions;
        if (!isNaN(parseFloat(m)) && isFinite(m)) {
            let n = Number(m);
            
            if (inLimits in tempLCBlocks[this.state.renderType]) {
                if (n < tempLCBlocks[this.state.renderType][inLimits][0]) {
                    if (tempLCBlocks[this.state.renderType][inLimits][0] < 0) {
                        n = 0
                        m = "0"
                    } else {
                        n = tempLCBlocks[this.state.renderType][inLimits][0]
                        m = String(tempLCBlocks[this.state.renderType][inLimits][0])
                    }
                } else if (n > tempLCBlocks[this.state.renderType][inLimits][1]) {
                    n = tempLCBlocks[this.state.renderType][inLimits][1]
                    m = String(tempLCBlocks[this.state.renderType][inLimits][1])
                }
            } else if (inCust in tempLCBlocks[this.state.renderType]) {
                n = tempLCBlocks[this.state.renderType].boundRef(n)
                m = String(n)
            }
            if (tempLCBlocks[this.state.renderType][inType] === 'int') {
                tempLCBlocks[this.state.renderType].control[inName] = Math.floor(n);
                m = String(Math.floor(n))
                tempLCBlocks[this.state.renderType].code = tempLCBlocks[this.state.renderType].codeRef(tempLCBlocks[this.state.renderType].control);
            } else {
                tempLCBlocks[this.state.renderType].control[inName] = n;
                tempLCBlocks[this.state.renderType].code = tempLCBlocks[this.state.renderType].codeRef(tempLCBlocks[this.state.renderType].control);
            }
        } else {
            if (tempLCBlocks[this.state.renderType][inType] === 'hexString') {
                // check if m is a valid hex string
                if (m.length === 10) {
                    let hexRegex = /^[0-9A-Fa-f]+$/;
                    if (hexRegex.test(m)) {
                        tempLCBlocks[this.state.renderType].control[inName] = m;
                    } else {
                        m = "E7E7E7E7E7"
                        tempLCBlocks[this.state.renderType].control[inName] = m;
                    }
                } else {
                    m = "E7E7E7E7E7"
                    tempLCBlocks[this.state.renderType].control[inName] = m;
                }
                tempLCBlocks[this.state.renderType].code = tempLCBlocks[this.state.renderType].codeRef(tempLCBlocks[this.state.renderType].control);
            } else {
                if (inLimits in tempLCBlocks[this.state.renderType]) {
                    if (tempLCBlocks[this.state.renderType][inLimits][0] < 0) {
                        m = "0"
                    } else {
                        m = String(tempLCBlocks[this.state.renderType][inLimits][0])
                    }
                } else {
                    m = "0"
                }
                tempLCBlocks[this.state.renderType].code = tempLCBlocks[this.state.renderType].codeRef(tempLCBlocks[this.state.renderType].control);
            }
        }

        //this.setState( {LCBlocksOptions: tempLCBlocks, [event.target.name]: m} );
        this.setState( {LCBlocksOptions: tempLCBlocks, [name]: m} );
        this.props.handleSubState(tempLCBlocks[this.state.renderType]);
    }

    handleIn = (event) => {
        let m = event.target.value;
        this.setState( {[event.target.name]: m} );
    }
    
    handleBtn = (num) => {

        let numStr = String(num);
        let btnMap = 'btn' + numStr + 'map'
        let btnOptions = 'btn' + numStr + 'Options'
        let btnName = 'btn' + numStr
        let btnText = 'btn' + numStr + 'Txt'

        let tempLCBlocks = this.state.LCBlocksOptions;

        let nowIndex = tempLCBlocks[this.state.renderType][btnOptions].indexOf(tempLCBlocks[this.state.renderType].control[btnText])
        nowIndex += 1
        if (nowIndex >= tempLCBlocks[this.state.renderType][btnOptions].length) {
            nowIndex = 0
        }
        tempLCBlocks[this.state.renderType].control[btnName] = 
                    tempLCBlocks[this.state.renderType][btnMap][tempLCBlocks[this.state.renderType][btnOptions][nowIndex]];

        if (btnMap in tempLCBlocks[this.state.renderType]) {
            tempLCBlocks[this.state.renderType].control[btnText] = tempLCBlocks[this.state.renderType][btnOptions][nowIndex];
            this.setState( {[btnText]: tempLCBlocks[this.state.renderType].control[btnText]} );
        } else {
            this.setState( {[btnText]: tempLCBlocks[this.state.renderType].control[btnName]} );
        }
        tempLCBlocks[this.state.renderType].code = tempLCBlocks[this.state.renderType].codeRef(tempLCBlocks[this.state.renderType].control);
        
        this.setState( {LCBlocksOptions: tempLCBlocks} );
        this.props.handleSubState(tempLCBlocks[this.state.renderType]);
    }



    render() {

        // Referenced below for setting styles
        const { classes } = this.props;

        return (
            <React.Fragment>
                <Box 
                    height={this.state.LCBlocksOptions[this.state.renderType].height}
                    style={{backgroundColor: this.state.LCBlocksOptions[this.state.renderType].color}}
                >
                    {this.state.LCBlocksOptions[this.state.renderType]?.title ? (
                        <Typography 
                            className={classes.titleText}
                            variant='h4'
                            style={{backgroundColor: this.state.LCBlocksOptions[this.state.renderType].color}}
                        >
                            {this.state.LCBlocksOptions[this.state.renderType].title}
                        </Typography>
                    ) : (
                        <div style={{ paddingTop: '8px' }}></div> // Add padding when there is no title
                    )}
                    {(this.state.renderType === 'idrone') && (
                        <Grid 
                            container 
                            spacing={0}
                            className={classes.grid}
                            direction="row"
                        >
                        <Grid item xs="auto">
                            <Typography 
                                className={classes.regularText}
                                style={{backgroundColor: this.state.LCBlocksOptions[this.state.renderType].color}}
                            >
                                {this.state.LCBlocksOptions[this.state.renderType].text1}
                            </Typography>
                        </Grid>
                        <Grid item xs="auto">
                            <Input 
                                className={classes.inputField}
                                name='in1'
                                style={{
                                    width: this.state.LCBlocksOptions[this.state.renderType].in1Width,
                                  }}
                                onChange = {this.handleIn}
                                onBlur = {(e) => this.handleInOnBlur(e, 'in1')}
                                value={this.state.in1}
                                disabled={this.props.isDisabled}
                                autoComplete="off"
                            />
                        </Grid>
                        
                        <Grid item xs="auto">
                            <Typography 
                                className={classes.regularText}
                                style={{backgroundColor: this.state.LCBlocksOptions[this.state.renderType].color}}
                            >
                                {this.state.LCBlocksOptions[this.state.renderType].text2}
                            </Typography>
                        </Grid>
                        <Grid item xs="auto">
                            <Input 
                                className={classes.inputField}
                                name='in2'
                                style={{
                                    width: this.state.LCBlocksOptions[this.state.renderType].in2Width,
                                  }}
                                onChange = {this.handleIn}
                                onBlur = {(e) => this.handleInOnBlur(e, 'in2')}
                                value={this.state.in2}
                                disabled={this.props.isDisabled}
                                autoComplete="off"
                            />
                        </Grid>
                        </Grid>
                    )}
                    {
                    ((this.state.renderType === 'iloop') 
                    || (this.state.renderType === 'ihover')) && (
                        <Grid 
                            container 
                            spacing={0}
                            className={classes.grid}
                            direction="row"
                        >
                        <Grid item xs="auto">
                            <Typography 
                                className={classes.regularText}
                                style={{backgroundColor: this.state.LCBlocksOptions[this.state.renderType].color}}
                            >
                                {this.state.LCBlocksOptions[this.state.renderType].text1}
                            </Typography>
                        </Grid>
                        <Grid item xs="auto">
                            <Input 
                                className={classes.inputField}
                                name='in1'
                                style={{
                                    width: this.state.LCBlocksOptions[this.state.renderType].inWidth,
                                  }}
                                onChange = {this.handleIn}
                                onBlur = {(e) => this.handleInOnBlur(e, 'in1')}
                                value={this.state.in1}
                                disabled={this.props.isDisabled}
                                autoComplete="off"
                            />
                        </Grid>
                        <Grid item xs="auto">
                            <Typography 
                                className={classes.regularText}
                                style={{backgroundColor: this.state.LCBlocksOptions[this.state.renderType].color}}
                            >
                                {this.state.LCBlocksOptions[this.state.renderType].text2}
                            </Typography>
                        </Grid>
                        </Grid>
                    )}
                    {this.state.renderType === 'icircle' && (
                        <Grid 
                            container 
                            spacing={0}
                            className={classes.grid}
                            direction="row"
                        >
                        <Grid item xs="auto">
                            <Typography 
                                className={classes.regularText}
                                style={{backgroundColor: this.state.LCBlocksOptions[this.state.renderType].color}}
                            >
                                {this.state.LCBlocksOptions[this.state.renderType].text1}
                            </Typography>
                        </Grid>
                        <Grid item xs="auto">
                            <Button
                                className={classes.textButton}
                                style={{backgroundColor:this.state.LCBlocksOptions[this.state.renderType].color}}
                                variant="contained"
                                onClick={() => this.handleBtn(1)}
                                disabled={this.props.isDisabled}
                            >
                                {this.state.btn1Txt}
                            </Button>
                        </Grid>
                        <Grid item xs="auto">
                            <Typography 
                                className={classes.regularText}
                                style={{backgroundColor: this.state.LCBlocksOptions[this.state.renderType].color}}
                            >
                                {this.state.LCBlocksOptions[this.state.renderType].text2}
                            </Typography>
                        </Grid>
                        <Grid item xs="auto">
                            <Input 
                                className={classes.inputField}
                                name='in1'
                                style={{
                                        width: this.state.LCBlocksOptions[this.state.renderType].inWidth,
                                      }}
                                onChange = {this.handleIn}
                                onBlur = {(e) => this.handleInOnBlur(e, 'in1')}
                                value={this.state.in1}
                                disabled={this.props.isDisabled}
                                autoComplete="off"
                            />
                        </Grid>
                        <Grid item xs="auto">
                            <Typography 
                                className={classes.regularText}
                                style={{backgroundColor: this.state.LCBlocksOptions[this.state.renderType].color}}
                            >
                                {this.state.LCBlocksOptions[this.state.renderType].text3}
                            </Typography>
                        </Grid>
                        <Grid item xs="auto">
                            <Input 
                                className={classes.inputField}
                                name='in2'
                                style={{
                                        width: this.state.LCBlocksOptions[this.state.renderType].inWidth,
                                      }}
                                onChange = {this.handleIn}
                                onBlur = {(e) => this.handleInOnBlur(e, 'in2')}
                                value={this.state.in2}
                                disabled={this.props.isDisabled}
                                autoComplete="off"
                            />
                        </Grid>
                        <Grid item xs="auto">
                            <Typography 
                                className={classes.regularText}
                                style={{backgroundColor: this.state.LCBlocksOptions[this.state.renderType].color}}
                            >
                                {this.state.LCBlocksOptions[this.state.renderType].text4}
                            </Typography>
                        </Grid>
                        </Grid>
                    )}
                    {((this.state.renderType === 'iyaw') || (this.state.renderType === 'imove')) && (
                        <Grid 
                            container 
                            spacing={0}
                            className={classes.grid}
                            direction="row"
                        >
                        <Grid item xs="auto">
                            <Typography 
                                className={classes.regularText}
                                style={{backgroundColor: this.state.LCBlocksOptions[this.state.renderType].color}}
                            >
                                {this.state.LCBlocksOptions[this.state.renderType].text1}
                            </Typography>
                        </Grid>
                        <Grid item xs="auto">
                            <Button
                                className={classes.textButton}
                                style={{backgroundColor:this.state.LCBlocksOptions[this.state.renderType].color}}
                                variant="contained"
                                onClick={() => this.handleBtn(1)}
                                disabled={this.props.isDisabled}
                            >
                                {this.state.btn1Txt}
                            </Button>
                        </Grid>
                        <Grid item xs="auto">
                            <Typography 
                                className={classes.regularText}
                                style={{backgroundColor: this.state.LCBlocksOptions[this.state.renderType].color}}
                            >
                                {this.state.LCBlocksOptions[this.state.renderType].text2}
                            </Typography>
                        </Grid>
                        <Grid item xs="auto">
                            <Input 
                                className={classes.inputField}
                                name='in1'
                                style={{
                                        width: this.state.LCBlocksOptions[this.state.renderType].inWidth,
                                      }}
                                onChange = {this.handleIn}
                                onBlur = {(e) => this.handleInOnBlur(e, 'in1')}
                                value={this.state.in1}
                                disabled={this.props.isDisabled}
                                autoComplete="off"
                            />
                        </Grid>
                        <Grid item xs="auto">
                            <Typography 
                                className={classes.regularText}
                                style={{backgroundColor: this.state.LCBlocksOptions[this.state.renderType].color}}
                            >
                                {this.state.LCBlocksOptions[this.state.renderType].text3}
                            </Typography>
                        </Grid>

                        </Grid>
                    )}
                    {(this.state.renderType === 'igo') && (
                        <React.Fragment>
                        <Grid 
                            container 
                            spacing={0}
                            className={classes.grid}
                            direction="row"
                        >
                        <Grid item xs="auto">
                            <Typography 
                                className={classes.regularText}
                                style={{backgroundColor: this.state.LCBlocksOptions[this.state.renderType].color}}
                            >
                                {this.state.LCBlocksOptions[this.state.renderType].text1}
                            </Typography>
                        </Grid>
                        <Grid item xs="auto">
                            <Input 
                                className={classes.inputField}
                                name='in1'
                                style={{
                                        width: this.state.LCBlocksOptions[this.state.renderType].inWidth,
                                      }}
                                onChange = {this.handleIn}
                                onBlur = {(e) => this.handleInOnBlur(e, 'in1')}
                                value={this.state.in1}
                                disabled={this.props.isDisabled}
                                autoComplete="off"
                            />
                        </Grid>
                        <Grid item xs="auto">
                            <Input 
                                className={classes.inputField}
                                name='in2'
                                style={{
                                        width: this.state.LCBlocksOptions[this.state.renderType].inWidth,
                                      }}
                                onChange = {this.handleIn}
                                onBlur = {(e) => this.handleInOnBlur(e, 'in2')}
                                value={this.state.in2}
                                disabled={this.props.isDisabled}
                                autoComplete="off"
                            />
                        </Grid>
                        <Grid item xs="auto">
                            <Input 
                                className={classes.inputField}
                                name='in3'
                                style={{
                                        width: this.state.LCBlocksOptions[this.state.renderType].inWidth,
                                      }}
                                onChange = {this.handleIn}
                                onBlur = {(e) => this.handleInOnBlur(e, 'in3')}
                                value={this.state.in3}
                                disabled={this.props.isDisabled}
                                autoComplete="off"
                            />
                        </Grid>
                        <Grid item xs="auto">
                            <Typography 
                                className={classes.regularText}
                                style={{backgroundColor: this.state.LCBlocksOptions[this.state.renderType].color}}
                            >
                                {this.state.LCBlocksOptions[this.state.renderType].text2}
                            </Typography>
                        </Grid>
                        </Grid>
                        <Grid 
                            container 
                            spacing={0}
                            className={classes.grid}
                            direction="row"
                        >
                        <Grid item xs="auto">
                            <Typography 
                                className={classes.regularText}
                                style={{backgroundColor: this.state.LCBlocksOptions[this.state.renderType].color}}
                            >
                                {this.state.LCBlocksOptions[this.state.renderType].text3}
                            </Typography>
                        </Grid>
                        <Grid item xs="auto">
                            <Input 
                                className={classes.inputField}
                                name='in4'
                                style={{
                                        width: this.state.LCBlocksOptions[this.state.renderType].inWidth,
                                      }}
                                onChange = {this.handleIn}
                                onBlur = {(e) => this.handleInOnBlur(e, 'in4')}
                                value={this.state.in4}
                                disabled={this.props.isDisabled}
                                autoComplete="off"
                            />
                        </Grid>
                        <Grid item xs="auto">
                            <Typography 
                                className={classes.regularText}
                                style={{backgroundColor: this.state.LCBlocksOptions[this.state.renderType].color}}
                            >
                                {this.state.LCBlocksOptions[this.state.renderType].text4}
                            </Typography>
                        </Grid>

                    </Grid>
                    </React.Fragment>
                    )}
                    {(this.state.renderType === 'irc') && (
                        <React.Fragment>
                        <Grid 
                            container 
                            spacing={0}
                            className={classes.grid}
                            direction="row"
                        >
                        <Grid item xs="auto">
                            <Button
                                className={classes.textButton}
                                style={{backgroundColor:this.state.LCBlocksOptions[this.state.renderType].color}}
                                variant="contained"
                                onClick={() => this.handleBtn(1)}
                                disabled={this.props.isDisabled}
                            >
                                {this.state.btn1Txt}
                            </Button>
                        </Grid>
                        <Grid item xs="auto">
                            <Input 
                                className={classes.inputFieldRC}
                                name='in1'
                                style={{
                                        width: this.state.LCBlocksOptions[this.state.renderType].inWidth,
                                      }}
                                onChange = {this.handleIn}
                                onBlur = {(e) => this.handleInOnBlur(e, 'in1')}
                                value={this.state.in1}
                                disabled={this.props.isDisabled}
                                autoComplete="off"
                            />
                        </Grid>
                        <Grid item xs="auto">
                            <Button
                                className={classes.textButton}
                                style={{backgroundColor:this.state.LCBlocksOptions[this.state.renderType].color}}
                                variant="contained"
                                onClick={() => this.handleBtn(2)}
                                disabled={this.props.isDisabled}
                            >
                                {this.state.btn2Txt}
                            </Button>
                        </Grid>
                        <Grid item xs="auto">
                            <Input 
                                className={classes.inputFieldRC}
                                name='in2'
                                style={{
                                        width: this.state.LCBlocksOptions[this.state.renderType].inWidth,
                                      }}
                                onChange = {this.handleIn}
                                onBlur = {(e) => this.handleInOnBlur(e, 'in2')}
                                value={this.state.in2}
                                disabled={this.props.isDisabled}
                                autoComplete="off"
                            />
                        </Grid>
                        </Grid>
                        <Grid 
                            container 
                            spacing={0}
                            className={classes.grid}
                            direction="row"
                        >
                        <Grid item xs="auto">
                            <Button
                                className={classes.textButton}
                                style={{backgroundColor:this.state.LCBlocksOptions[this.state.renderType].color}}
                                variant="contained"
                                onClick={() => this.handleBtn(3)}
                                disabled={this.props.isDisabled}
                            >
                                {this.state.btn3Txt}
                            </Button>
                        </Grid>
                        <Grid item xs="auto">
                            <Input 
                                className={classes.inputFieldRC}
                                name='in3'
                                style={{
                                        width: this.state.LCBlocksOptions[this.state.renderType].inWidth,
                                      }}
                                onChange = {this.handleIn}
                                onBlur = {(e) => this.handleInOnBlur(e, 'in3')}
                                value={this.state.in3}
                                disabled={this.props.isDisabled}
                                autoComplete="off"
                            />
                        </Grid>
                        <Grid item xs="auto">
                            <Button
                                className={classes.textButton}
                                style={{backgroundColor:this.state.LCBlocksOptions[this.state.renderType].color}}
                                variant="contained"
                                onClick={() => this.handleBtn(4)}
                                disabled={this.props.isDisabled}
                            >
                                {this.state.btn4Txt}
                            </Button>
                        </Grid>
                        <Grid item xs="auto">
                            <Input 
                                className={classes.inputField}
                                name='in4'
                                style={{
                                        width: this.state.LCBlocksOptions[this.state.renderType].inWidth,
                                      }}
                                onChange = {this.handleIn}
                                onBlur = {(e) => this.handleInOnBlur(e, 'in4')}
                                value={this.state.in4}
                                disabled={this.props.isDisabled}
                                autoComplete="off"
                            />
                        </Grid>
                        </Grid>
                        <Grid 
                            container 
                            spacing={0}
                            className={classes.grid}
                            direction="row"
                        >
                        <Grid item xs="auto">
                            <Typography 
                                className={classes.regularText}
                                style={{backgroundColor: this.state.LCBlocksOptions[this.state.renderType].color}}
                            >
                                {this.state.LCBlocksOptions[this.state.renderType].text1}
                            </Typography>
                        </Grid>
                        <Grid item xs="auto">
                            <Input 
                                className={classes.inputField}
                                name='in5'
                                style={{
                                        width: this.state.LCBlocksOptions[this.state.renderType].inWidth,
                                      }}
                                onChange = {this.handleIn}
                                onBlur = {(e) => this.handleInOnBlur(e, 'in5')}
                                value={this.state.in5}
                                disabled={this.props.isDisabled}
                                autoComplete="off"
                            />
                        </Grid>
                        <Grid item xs="auto">
                            <Typography 
                                className={classes.regularText}
                                style={{backgroundColor: this.state.LCBlocksOptions[this.state.renderType].color}}
                            >
                                {this.state.LCBlocksOptions[this.state.renderType].text2}
                            </Typography>
                        </Grid>
                        </Grid>
                        </React.Fragment>
                    )}

                </Box>
            </React.Fragment>
        );
    }



}


export default withStyles(styles)(LocoCrazeBlocks);